export default "__VITE_ASSET__Ekrug_Na__"